import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/analytics';

/**
 * Fires a GA4-compatible page_view event to the dataLayer on every client-side
 * route change. React Router's in-app navigation doesn't trigger a browser
 * page load, so without this the GA4 pageview tag only fires once per session
 * (on first HTML load) and funnel reports under-count every route past the
 * landing page.
 *
 * Mounted inside <BrowserRouter> so useLocation() can read the current path.
 */
export function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
